import { render, staticRenderFns } from "./infocomp.vue?vue&type=template&id=0d2007a8&scoped=true&"
import script from "./infocomp.vue?vue&type=script&lang=js&"
export * from "./infocomp.vue?vue&type=script&lang=js&"
import style0 from "./infocomp.vue?vue&type=style&index=0&id=0d2007a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2007a8",
  null
  
)

export default component.exports